export const styles = {
  guidedTour: {
    position: 'absolute',
    top: '1.75rem',
    right: '-0.875rem',
    zIndex: 1,
  },
};
